<template>

  <div class="results">

    <template v-if="contentType == 'article'">

      <div class="articles" :class="{ 's_has-results' : hasResults }">

        <div class="article l_staff" :class="[ `l_image-${post.imageStyle}`, { 's_loading' : isLoading } ]" v-for="post in filteredPosts" :key="post.id">
          <div class="article-inner">

            <a :href=post.url :target=post.target class="article-imagebox" v-if="post.thumbUrl">
              <picture class="article-image">
                <img :src="post.thumbUrl" :data-src="post.imageUrl" alt="" class="lazyload">
              </picture>
              <div class="article-overlay" v-if="post.description">
                <p v-html="post.description"></p>
              </div>
            </a>

            <div class="article-main">
              <h3 class="article-title"><a :href=post.url :target=post.target v-html="post.title"></a></h3>
              <p class="article-text" v-html="post.subtitle"></p>
              <a :href="post.url" :target="post.target" class="article-btn">
                <span v-if="post.target == '_blank'" >Download</span>
                <span v-else>More</span>
              </a>
            </div>

          </div>
        </div>

      </div>

    </template>

    <template v-if="contentType == 'project'">

      <div class="projects" :class="{ 's_has-results' : hasResults }">

        <a :href=post.url :target=post.target class="project" :class="[ `l_${post.categories[0].slug}`, { 's_loading' : isLoading }]" v-for="post in filteredPosts" :key="post.id">
          <div class="project-inner">

            <div class="project-imagebox" v-if="post.thumbUrl">
              <div class="project-overlay">
                <svg class="project-overlayicon"><use xlink:href="#download"></use></svg>
              </div>
              <picture class="project-image">
                <img :src=post.thumbUrl :data-src=post.imageUrl alt=""  class="lazyload">
              </picture>
            </div>

            <div class="project-main">
              <p class="project-date" v-if="post.categories[0].slug != 'case-studies'">
                <span v-html="post.month" v-if="post.categories[0].slug == 'peer-reviews'"></span>
                <span v-html="post.year"></span>
              </p>
              <h3 class="project-title" v-html="post.title"></h3>
              <p class="project-subtitle" v-html="post.subtitle" v-if="post.categories[0].slug == 'conference-presentations'"></p>
              <!-- <a :href=post.url :target=post.target class="project-btn">Download</a> -->
            </div>

          </div>
        </a>

      </div>

    </template>

    <div v-if="isEmpty">
      <p class="h2">No results found</p>
      <p>Check the spelling or try searching for a more general term.</p>
    </div>

  </div>

</template>

<script>
import EventBus from '../utils/event-bus';
import FilterSelect from "../components/Filter-Select";
import FilterText from "../components/Filter-Text";

export default {
  name: "PostsFilter",
  data() {
    return {

      keywords: '',
      year: false,
      category: false,
      hasResults: false,
      isEmpty: false,
      isLoading: false,
      filteredPosts: [],
      featuredPost: false

    };
  },
  props: {
    categories: Array,
    posts: Array,
    tag: String,
    categoryCode: {
      type: String,
      default: 'category'
    },
    categoryCodePlural: {
      type: String,
      default: 'categories'
    },
    contentType: {
      type: String,
      required: false,
      default: 'project'
    }
  },
  computed: {
  },
  components: {
    FilterSelect,
    FilterText
  },
  methods: {

    filterPosts() {

      this.isLoading = true;
      var matchesRequired = 0;

      if (this.keywords) {
        matchesRequired++;
      }

      if (this.category) {
        matchesRequired++;
      }

      if (this.year) {
        matchesRequired++;
      }

      this.filteredPosts = this.posts.filter((post) => {
        var isValid = false;
        var matches = 0;

        // console.log(post);

        if (this.keywords.length) {

          var postTitle = '';
          if (typeof post.title !== 'undefined' && post.title !== null) {
            postTitle = post.title.toLowerCase();
            // console.log(postTitle);
          }

          var postSearchTitle = '';
          if (typeof post.searchTitle !== 'undefined' && post.searchTitle !== null) {
            postSearchTitle = post.searchTitle.toLowerCase();
          }

          var postSummary = '';
          if (typeof post.summary !== 'undefined' && post.summary !== null) {
            postSummary = post.summary.toLowerCase();
          }


          if (
            postTitle.includes(this.keywords) ||
            postSearchTitle.includes(this.keywords) ||
            postSummary.includes(this.keywords) ) {
            matches++;
          }
        }

        if (this.category) {
          var tagsString = JSON.stringify(post.categories);
          if (tagsString.toLowerCase().indexOf(this.category) > -1) {
            matches++;
          }
        }

        if (this.year) {
          if (post.year !== null && post.year.toLowerCase().indexOf(this.year) > -1) {
            matches++;
          }
        }

        if (matches == matchesRequired) {
          isValid = true;
        }
        return isValid;
      });

      if (this.filteredPosts.length) {
        this.hasResults = true;
        this.isEmpty = false;
      } else {
        this.hasResults = false;
        this.isEmpty = true;
      }

      setTimeout(() => {
        this.isLoading = false;
      }, 500);

    }

  },
  mounted() {

    EventBus.$on('FILTER_VAR', (varName, varVal) => {
      if (varName.length && typeof varVal !== 'undefined') {
        this[varName] = varVal;
        this.filterPosts();
      }
    });

    this.filterPosts();

  },
  updated() {
    // lazyload();
  }
};
</script>

<style scoped>
</style>